import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'access-collect',
  version: '1.0.0',
  properties: [
    {
      key: 'environment',
      label: 'Environment',
      type: 'options',
      required: true,
      default: 'preprod',
      options: [
        { 
          value: 'preprod', 
          name: 'Preprod'
        },
        { 
          value: 'staging', 
          name: 'Staging'
        },
        { 
          value: 'production', 
          name: 'Production'
        },
      ],
    },
    {
      key: 'action',
      label: 'Action',
      type: 'options',
      required: true,
      default: 'getAllCustomers',
      options: [
        { value: 'getAllCustomers', name: 'Get All Customers' },
        { value: 'getAllTransactions', name: 'Get All Transactions' },
        { value: 'getAllDisputes', name: 'Get All Disputes' },
        { value: 'getAllCollectionStrategies', name: 'Get All Collection Strategies' },
        { value: 'updateDispute', name: 'Update a Dispute' },
      ],
    },
    {
      key: 'companyId',
      label: 'Company ID',
      type: 'number',
      required: true,
      placeholder: '1001',
      description: 'The company ID for multi-tenancy (X-Company-Id header)',
    },
    {
      key: 'instanceId',
      label: 'Instance ID',
      type: 'string',
      required: false,
      placeholder: 'sub_12345',
      description: 'Optional instance ID for the request (X-Instance-Id header)',
    },
    {
      key: 'queryParams',
      label: 'Query Parameters',
      type: 'string',
      required: false,
      placeholder: 'Page=1&PageSize=50&Search=customer&RiskLevel=high',
      description: 'Optional query parameters (e.g., Page=1&PageSize=50&Search=customer)',
    },
    {
      key: 'disputeId',
      label: 'Dispute ID',
      type: 'string',
      required: true,
      placeholder: '123 or {{previousNode.disputeId}}',
      description: 'The dispute ID to update (supports variable interpolation)',
      displayOptions: {
        show: {
          action: ['updateDispute'],
        },
      },
    },
    {
      key: 'body',
      label: 'Request Body',
      type: 'json',
      required: true,
      placeholder: '{"statusId": 1, "priorityId": 2, "description": "Updated description"}',
      description: 'JSON body for the update request (supports variable interpolation)',
      displayOptions: {
        show: {
          action: ['updateDispute'],
        },
      },
    },
  ],
};

export default schema;
